var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgToolStackImageSync = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h28v28H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m16.435 14.488.087.086a1.95 1.95 0 0 0 2.758 0l3.866-3.869a2.936 2.936 0 0 0 0-4.137L21.43 4.854a2.932 2.932 0 0 0-4.136 0L13.428 8.72a1.95 1.95 0 0 0 0 2.758l.087.087M11.565 13.512l-.087-.087a1.95 1.95 0 0 0-2.758 0l-3.867 3.87a2.935 2.935 0 0 0 0 4.137l1.714 1.714a2.931 2.931 0 0 0 4.137 0l3.866-3.866a1.949 1.949 0 0 0 0-2.759l-.087-.087M10.207 17.793l7.584-7.586",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))));
export { SvgToolStackImageSync as ReactComponent };
export default __webpack_public_path__ + "assets/images/tool-stack-image-sync.svg";